import { Navigate, Outlet } from 'react-router-dom'
export const PrivateRoutes = () => {
  const userdetails = localStorage.getItem("userdetail");
  let token = "";
  if (userdetails) {
    token = (JSON.parse(userdetails)).accessToken;
  }
  return (
    token ? <Outlet /> : <Navigate to='/' />
  )
}